import MainRate from './MainRate';

export default MainRate;
